import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IParams {
  catalog_uid?: string;
}

export const useGetCatalogAllProductsQuery = ({ catalog_uid }: IParams) => {
  return useQuery({
    queryKey: ['getCatalogAllProducts', { catalog_uid }],
    queryFn: async () => {
      return await Api.products.getCatalogProducts({}, catalog_uid || '');
    },
  });
};
